import React from "react";
import PropTypes from "prop-types";
import Card from "./Card";
import { WidgetStyle } from "./Card.styled";

const WidgetCard = (props) => {
  return <WidgetStyle {...props} as={Card} />;
};

WidgetCard.defaultProps = {
  ...Card.defaultProps,
  backgroundLevel: null,
};

WidgetCard.propTypes = {
  ...Card.propTypes,
  backgroundLevel: PropTypes.oneOf([
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
  ]),
};

export default WidgetCard;
